import moment from 'moment';

import { Http } from '../../../../support';

const from = moment().subtract(1, 'month').format('YYYY-MM-DD');
const to = moment().format('YYYY-MM-DD');

export const initialState = {
  busy: false,
  data: [],
  filters: {
    page: 1,
    search: '',
    from,
    to,
  },
  selectedRows: [],
  selectedRowKeys: [],
  result: undefined,
  error: undefined,
  pagination: {
    limit: 25,
  },
};

const setSelectedRows = (store, data) => {
  store.setState((state) => {
    const { external_list } = state.autofacturacion;

    state.autofacturacion.external_list = {
      ...external_list,
      ...data,
    };
  });
};

const change = (store, data) => {
  store.setState((state) => {
    const { external_list } = state.autofacturacion;

    state.autofacturacion.external_list.data = {
      ...external_list.data,
      ...data,
    };
  });
};

const paginate = async (store, params) => {
  store.setState((state) => {
    const { external } = state;

    external.receptores.autofacturacion.list = {
      ...external.receptores.autofacturacion.list,
      busy: true,
      filters: {
        ...external.receptores.autofacturacion.list.filters,
        ...params,
      },
      pagination: {
        ...external.receptores.autofacturacion.list.pagination,
        limit: params.limit ?? 25,
      },
    };
  });

  try {
    const { list } = store.state.external.receptores.autofacturacion;

    const body = {
      ...list.filters,
      ...params,
    };

    const response = await Http.get(`/ext/receptores/autofacturacion/tickets`, { params: body });

    store.setState((state) => {
      const { external } = state;

      external.receptores.autofacturacion.list = {
        ...external.receptores.autofacturacion.list,
        busy: false,
        data: response.data,
        pagination: {
          ...external.receptores.autofacturacion.list.pagination,
          ...response.meta.pagination,
          links: undefined,
        },
      };
    });
  } catch (error) {
    store.setState((state) => {
      const { external } = state;

      external.receptores.autofacturacion.list = {
        ...external.receptores.autofacturacion.list,
        busy: false,
        error: error.data || error,
      };
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    const { external } = state;

    external.receptores.autofacturacion.list = {
      ...external.receptores.autofacturacion.list,
      ...initialState,
    };
  });
};

const ExternalAutofacturacionTicketListStore = {
  state: () => initialState,
  actions: {
    change,
    setSelectedRows,
    paginate,
    reset,
  },
};

export default ExternalAutofacturacionTicketListStore;
